import React from 'react'
import { Section } from '@shared/components/section'
import { ExternalPaths } from '@shared/menu-items/paths'
import SkolkovoLogo from '@shared/svg/skolkovo.svg'

import styles from './style.module.scss'

export const View = () => (
	<Section className={styles.wrapper}>
		<a
			href={ExternalPaths.skolkovo}
			target='_blank'
			rel='noopener noreferrer nofollow'
			className={styles.item}
		>
			<SkolkovoLogo className={styles.skolkovo} />
			<span className={styles.itemText}>Участник проекта инновационного центра «Сколково»</span>
		</a>
	</Section>
)
